/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Checkin_No_Deck_WarnInputs */



/**
* | output |
* | --- |
* | "No decklist yet. You can check in, but upload it now to avoid a judge warning or penalty." |
*
* @param {Tournament_Checkin_No_Deck_WarnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_checkin_no_deck_warn = /** @type {((inputs?: Tournament_Checkin_No_Deck_WarnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Checkin_No_Deck_WarnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de decklist. Vous pouvez pointer, mais envoyez-la maintenant pour éviter un avertissement ou une pénalité du juge.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay decklist. Puede hacer check-in, pero súbala ahora para evitar un aviso o una penalización del juez.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda sem decklist. Você pode fazer check-in, mas envie-a agora para evitar uma advertência ou penalidade do juiz.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ancora nessuna decklist. Puoi fare il check-in, ma caricala ora per evitare un avvertimento o una penalità del giudice.")
	return /** @type {LocalizedString} */ ("No decklist yet. You can check in, but upload it now to avoid a judge warning or penalty.")
});